import { format } from 'date-fns';

export const getDateString = (date: Date): string => format(date, 'yyyy-MM-dd');
